module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_5.d24ca89b.png";